"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: testapi/payment-simulation-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftestapi%2Fpayment-simulation-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentSimulationServiceClient = exports.cardBackendToJSON = exports.cardBackendFromJSON = exports.SimulateCashAdvanceSettlementResponse = exports.SimulateCashAdvanceSettlementRequest = exports.SimulateSettlementResponse = exports.SimulateSettlementRequest = exports.SimulateLoseDisputeResponse = exports.SimulateLoseDisputeRequest = exports.SimulateWinDisputeResponse = exports.SimulateWinDisputeRequest = exports.SimulateOpenDisputeResponse = exports.SimulateOpenDisputeRequest = exports.SimulateForceRefundResponse = exports.SimulateForceRefundRequest = exports.SimulateRefundResponse = exports.SimulateRefundRequest = exports.SimulateReversalResponse = exports.SimulateReversalRequest = exports.SimulateForceCaptureResponse = exports.SimulateForceCaptureRequest = exports.SimulateCaptureResponse = exports.SimulateCaptureRequest = exports.SimulateAuthorizationResponse = exports.SimulateAuthorizationRequest = exports.CardBackend = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const amount_1 = require("../common/amount");
const dispute_loss_reason_1 = require("../common/dispute-loss-reason");
const dispute_reason_1 = require("../common/dispute-reason");
const internal_payment_card_1 = require("../ledger/internal-payment-card");
const payment_context_1 = require("../ledger/payment-context");
const transaction_1 = require("../ledger/transaction");
const protobufPackage = 'com.step.testapi.payment.proto';
var CardBackend;
(function (CardBackend) {
    CardBackend["INVALID_CARD_BACKEND"] = "INVALID_CARD_BACKEND";
    CardBackend["LEDGER"] = "LEDGER";
    CardBackend["STRIPE"] = "STRIPE";
    CardBackend["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CardBackend || (exports.CardBackend = CardBackend = {}));
function createBaseSimulateAuthorizationRequest() {
    return {
        cardBackend: CardBackend.INVALID_CARD_BACKEND,
        cardId: '',
        amount: amount_1.Amount.fromPartial({}),
        chargeId: '',
        supportsPartial: false,
        context: undefined,
        internalContext: undefined,
        controlCategory: transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY,
    };
}
exports.SimulateAuthorizationRequest = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.cardBackend)) {
            message.cardBackend = cardBackendFromJSON(object.cardBackend);
        }
        if (isSet(object.chargeId)) {
            message.chargeId = globalThis.String(object.chargeId);
        }
        if (isSet(object.supportsPartial)) {
            message.supportsPartial = globalThis.Boolean(object.supportsPartial);
        }
        if (isSet(object.context)) {
            message.context = payment_context_1.PaymentContext.fromJSON(object.context);
        }
        if (isSet(object.internalContext)) {
            message.internalContext = internal_payment_card_1.CardInternalPaymentContext.fromJSON(object.internalContext);
        }
        if (isSet(object.controlCategory)) {
            message.controlCategory = (0, transaction_1.controlCategoryFromJSON)(object.controlCategory);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardBackend !== undefined && message.cardBackend !== CardBackend.INVALID_CARD_BACKEND) {
            obj.cardBackend = cardBackendToJSON(message.cardBackend);
        }
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.chargeId !== undefined && message.chargeId !== '') {
            obj.chargeId = message.chargeId;
        }
        if (message.supportsPartial !== undefined && message.supportsPartial !== false) {
            obj.supportsPartial = message.supportsPartial;
        }
        if (message.context !== undefined) {
            obj.context = payment_context_1.PaymentContext.toJSON(message.context);
        }
        if (message.internalContext !== undefined) {
            obj.internalContext = internal_payment_card_1.CardInternalPaymentContext.toJSON(message.internalContext);
        }
        if (message.controlCategory !== undefined &&
            message.controlCategory !== transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY) {
            obj.controlCategory = (0, transaction_1.controlCategoryToJSON)(message.controlCategory);
        }
        return obj;
    },
    create(base) {
        return exports.SimulateAuthorizationRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateAuthorizationRequest();
        message.cardBackend = object.cardBackend ?? CardBackend.INVALID_CARD_BACKEND;
        message.cardId = object.cardId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.chargeId = object.chargeId ?? '';
        message.supportsPartial = object.supportsPartial ?? false;
        message.context = (object.context !== undefined && object.context !== null)
            ? payment_context_1.PaymentContext.fromPartial(object.context)
            : undefined;
        message.internalContext =
            (object.internalContext !== undefined && object.internalContext !== null)
                ? internal_payment_card_1.CardInternalPaymentContext.fromPartial(object.internalContext)
                : undefined;
        message.controlCategory = object.controlCategory ?? transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY;
        return message;
    },
};
function createBaseSimulateAuthorizationResponse() {
    return { chargeId: '' };
}
exports.SimulateAuthorizationResponse = {
    fromJSON(object) {
        const message = {
            chargeId: isSet(object.chargeId) ? globalThis.String(object.chargeId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.chargeId !== '') {
            obj.chargeId = message.chargeId;
        }
        return obj;
    },
    create(base) {
        return exports.SimulateAuthorizationResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateAuthorizationResponse();
        message.chargeId = object.chargeId ?? '';
        return message;
    },
};
function createBaseSimulateCaptureRequest() {
    return {
        cardBackend: CardBackend.INVALID_CARD_BACKEND,
        chargeId: '',
        cardId: '',
        amount: undefined,
        controlCategory: transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY,
    };
}
exports.SimulateCaptureRequest = {
    fromJSON(object) {
        const message = {
            chargeId: isSet(object.chargeId) ? globalThis.String(object.chargeId) : '',
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
        };
        if (isSet(object.cardBackend)) {
            message.cardBackend = cardBackendFromJSON(object.cardBackend);
        }
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        if (isSet(object.controlCategory)) {
            message.controlCategory = (0, transaction_1.controlCategoryFromJSON)(object.controlCategory);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardBackend !== undefined && message.cardBackend !== CardBackend.INVALID_CARD_BACKEND) {
            obj.cardBackend = cardBackendToJSON(message.cardBackend);
        }
        if (message.chargeId !== '') {
            obj.chargeId = message.chargeId;
        }
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.controlCategory !== undefined &&
            message.controlCategory !== transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY) {
            obj.controlCategory = (0, transaction_1.controlCategoryToJSON)(message.controlCategory);
        }
        return obj;
    },
    create(base) {
        return exports.SimulateCaptureRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateCaptureRequest();
        message.cardBackend = object.cardBackend ?? CardBackend.INVALID_CARD_BACKEND;
        message.chargeId = object.chargeId ?? '';
        message.cardId = object.cardId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        message.controlCategory = object.controlCategory ?? transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY;
        return message;
    },
};
function createBaseSimulateCaptureResponse() {
    return { captureId: '' };
}
exports.SimulateCaptureResponse = {
    fromJSON(object) {
        const message = {
            captureId: isSet(object.captureId) ? globalThis.String(object.captureId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.captureId !== '') {
            obj.captureId = message.captureId;
        }
        return obj;
    },
    create(base) {
        return exports.SimulateCaptureResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateCaptureResponse();
        message.captureId = object.captureId ?? '';
        return message;
    },
};
function createBaseSimulateForceCaptureRequest() {
    return {
        cardBackend: CardBackend.INVALID_CARD_BACKEND,
        cardId: '',
        amount: amount_1.Amount.fromPartial({}),
        context: undefined,
        controlCategory: transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY,
    };
}
exports.SimulateForceCaptureRequest = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.cardBackend)) {
            message.cardBackend = cardBackendFromJSON(object.cardBackend);
        }
        if (isSet(object.context)) {
            message.context = payment_context_1.PaymentContext.fromJSON(object.context);
        }
        if (isSet(object.controlCategory)) {
            message.controlCategory = (0, transaction_1.controlCategoryFromJSON)(object.controlCategory);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardBackend !== undefined && message.cardBackend !== CardBackend.INVALID_CARD_BACKEND) {
            obj.cardBackend = cardBackendToJSON(message.cardBackend);
        }
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.context !== undefined) {
            obj.context = payment_context_1.PaymentContext.toJSON(message.context);
        }
        if (message.controlCategory !== undefined &&
            message.controlCategory !== transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY) {
            obj.controlCategory = (0, transaction_1.controlCategoryToJSON)(message.controlCategory);
        }
        return obj;
    },
    create(base) {
        return exports.SimulateForceCaptureRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateForceCaptureRequest();
        message.cardBackend = object.cardBackend ?? CardBackend.INVALID_CARD_BACKEND;
        message.cardId = object.cardId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.context = (object.context !== undefined && object.context !== null)
            ? payment_context_1.PaymentContext.fromPartial(object.context)
            : undefined;
        message.controlCategory = object.controlCategory ?? transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY;
        return message;
    },
};
function createBaseSimulateForceCaptureResponse() {
    return { chargeId: '' };
}
exports.SimulateForceCaptureResponse = {
    fromJSON(object) {
        const message = {
            chargeId: isSet(object.chargeId) ? globalThis.String(object.chargeId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.chargeId !== '') {
            obj.chargeId = message.chargeId;
        }
        return obj;
    },
    create(base) {
        return exports.SimulateForceCaptureResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateForceCaptureResponse();
        message.chargeId = object.chargeId ?? '';
        return message;
    },
};
function createBaseSimulateReversalRequest() {
    return {
        cardBackend: CardBackend.INVALID_CARD_BACKEND,
        chargeId: '',
        cardId: '',
        amount: undefined,
        controlCategory: transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY,
    };
}
exports.SimulateReversalRequest = {
    fromJSON(object) {
        const message = {
            chargeId: isSet(object.chargeId) ? globalThis.String(object.chargeId) : '',
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
        };
        if (isSet(object.cardBackend)) {
            message.cardBackend = cardBackendFromJSON(object.cardBackend);
        }
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        if (isSet(object.controlCategory)) {
            message.controlCategory = (0, transaction_1.controlCategoryFromJSON)(object.controlCategory);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardBackend !== undefined && message.cardBackend !== CardBackend.INVALID_CARD_BACKEND) {
            obj.cardBackend = cardBackendToJSON(message.cardBackend);
        }
        if (message.chargeId !== '') {
            obj.chargeId = message.chargeId;
        }
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.controlCategory !== undefined &&
            message.controlCategory !== transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY) {
            obj.controlCategory = (0, transaction_1.controlCategoryToJSON)(message.controlCategory);
        }
        return obj;
    },
    create(base) {
        return exports.SimulateReversalRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateReversalRequest();
        message.cardBackend = object.cardBackend ?? CardBackend.INVALID_CARD_BACKEND;
        message.chargeId = object.chargeId ?? '';
        message.cardId = object.cardId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        message.controlCategory = object.controlCategory ?? transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY;
        return message;
    },
};
function createBaseSimulateReversalResponse() {
    return { reverseId: '' };
}
exports.SimulateReversalResponse = {
    fromJSON(object) {
        const message = {
            reverseId: isSet(object.reverseId) ? globalThis.String(object.reverseId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.reverseId !== '') {
            obj.reverseId = message.reverseId;
        }
        return obj;
    },
    create(base) {
        return exports.SimulateReversalResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateReversalResponse();
        message.reverseId = object.reverseId ?? '';
        return message;
    },
};
function createBaseSimulateRefundRequest() {
    return {
        cardBackend: CardBackend.INVALID_CARD_BACKEND,
        chargeId: '',
        cardId: '',
        amount: undefined,
        controlCategory: transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY,
    };
}
exports.SimulateRefundRequest = {
    fromJSON(object) {
        const message = {
            chargeId: isSet(object.chargeId) ? globalThis.String(object.chargeId) : '',
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
        };
        if (isSet(object.cardBackend)) {
            message.cardBackend = cardBackendFromJSON(object.cardBackend);
        }
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        if (isSet(object.controlCategory)) {
            message.controlCategory = (0, transaction_1.controlCategoryFromJSON)(object.controlCategory);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardBackend !== undefined && message.cardBackend !== CardBackend.INVALID_CARD_BACKEND) {
            obj.cardBackend = cardBackendToJSON(message.cardBackend);
        }
        if (message.chargeId !== '') {
            obj.chargeId = message.chargeId;
        }
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.controlCategory !== undefined &&
            message.controlCategory !== transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY) {
            obj.controlCategory = (0, transaction_1.controlCategoryToJSON)(message.controlCategory);
        }
        return obj;
    },
    create(base) {
        return exports.SimulateRefundRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateRefundRequest();
        message.cardBackend = object.cardBackend ?? CardBackend.INVALID_CARD_BACKEND;
        message.chargeId = object.chargeId ?? '';
        message.cardId = object.cardId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        message.controlCategory = object.controlCategory ?? transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY;
        return message;
    },
};
function createBaseSimulateRefundResponse() {
    return { refundId: '' };
}
exports.SimulateRefundResponse = {
    fromJSON(object) {
        const message = {
            refundId: isSet(object.refundId) ? globalThis.String(object.refundId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.refundId !== '') {
            obj.refundId = message.refundId;
        }
        return obj;
    },
    create(base) {
        return exports.SimulateRefundResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateRefundResponse();
        message.refundId = object.refundId ?? '';
        return message;
    },
};
function createBaseSimulateForceRefundRequest() {
    return {
        cardBackend: CardBackend.INVALID_CARD_BACKEND,
        cardId: '',
        amount: amount_1.Amount.fromPartial({}),
        context: undefined,
        controlCategory: transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY,
    };
}
exports.SimulateForceRefundRequest = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.cardBackend)) {
            message.cardBackend = cardBackendFromJSON(object.cardBackend);
        }
        if (isSet(object.context)) {
            message.context = payment_context_1.PaymentContext.fromJSON(object.context);
        }
        if (isSet(object.controlCategory)) {
            message.controlCategory = (0, transaction_1.controlCategoryFromJSON)(object.controlCategory);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardBackend !== undefined && message.cardBackend !== CardBackend.INVALID_CARD_BACKEND) {
            obj.cardBackend = cardBackendToJSON(message.cardBackend);
        }
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.context !== undefined) {
            obj.context = payment_context_1.PaymentContext.toJSON(message.context);
        }
        if (message.controlCategory !== undefined &&
            message.controlCategory !== transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY) {
            obj.controlCategory = (0, transaction_1.controlCategoryToJSON)(message.controlCategory);
        }
        return obj;
    },
    create(base) {
        return exports.SimulateForceRefundRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateForceRefundRequest();
        message.cardBackend = object.cardBackend ?? CardBackend.INVALID_CARD_BACKEND;
        message.cardId = object.cardId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.context = (object.context !== undefined && object.context !== null)
            ? payment_context_1.PaymentContext.fromPartial(object.context)
            : undefined;
        message.controlCategory = object.controlCategory ?? transaction_1.ControlCategory.INVALID_CONTROL_CATEGORY;
        return message;
    },
};
function createBaseSimulateForceRefundResponse() {
    return { refundId: '' };
}
exports.SimulateForceRefundResponse = {
    fromJSON(object) {
        const message = {
            refundId: isSet(object.refundId) ? globalThis.String(object.refundId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.refundId !== '') {
            obj.refundId = message.refundId;
        }
        return obj;
    },
    create(base) {
        return exports.SimulateForceRefundResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateForceRefundResponse();
        message.refundId = object.refundId ?? '';
        return message;
    },
};
function createBaseSimulateOpenDisputeRequest() {
    return {
        cardBackend: CardBackend.INVALID_CARD_BACKEND,
        cardId: '',
        chargeId: '',
        reason: dispute_reason_1.DisputeReason.INVALID_DISPUTE_REASON,
        amount: undefined,
    };
}
exports.SimulateOpenDisputeRequest = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
            chargeId: isSet(object.chargeId) ? globalThis.String(object.chargeId) : '',
        };
        if (isSet(object.cardBackend)) {
            message.cardBackend = cardBackendFromJSON(object.cardBackend);
        }
        if (isSet(object.reason)) {
            message.reason = (0, dispute_reason_1.disputeReasonFromJSON)(object.reason);
        }
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardBackend !== undefined && message.cardBackend !== CardBackend.INVALID_CARD_BACKEND) {
            obj.cardBackend = cardBackendToJSON(message.cardBackend);
        }
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.chargeId !== '') {
            obj.chargeId = message.chargeId;
        }
        if (message.reason !== undefined && message.reason !== dispute_reason_1.DisputeReason.INVALID_DISPUTE_REASON) {
            obj.reason = (0, dispute_reason_1.disputeReasonToJSON)(message.reason);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.SimulateOpenDisputeRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateOpenDisputeRequest();
        message.cardBackend = object.cardBackend ?? CardBackend.INVALID_CARD_BACKEND;
        message.cardId = object.cardId ?? '';
        message.chargeId = object.chargeId ?? '';
        message.reason = object.reason ?? dispute_reason_1.DisputeReason.INVALID_DISPUTE_REASON;
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        return message;
    },
};
function createBaseSimulateOpenDisputeResponse() {
    return { issuerReferenceId: '' };
}
exports.SimulateOpenDisputeResponse = {
    fromJSON(object) {
        const message = {
            issuerReferenceId: isSet(object.issuerReferenceId)
                ? globalThis.String(object.issuerReferenceId)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.issuerReferenceId !== '') {
            obj.issuerReferenceId = message.issuerReferenceId;
        }
        return obj;
    },
    create(base) {
        return exports.SimulateOpenDisputeResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateOpenDisputeResponse();
        message.issuerReferenceId = object.issuerReferenceId ?? '';
        return message;
    },
};
function createBaseSimulateWinDisputeRequest() {
    return { cardBackend: CardBackend.INVALID_CARD_BACKEND, issuerReferenceId: '' };
}
exports.SimulateWinDisputeRequest = {
    fromJSON(object) {
        const message = {
            issuerReferenceId: isSet(object.issuerReferenceId)
                ? globalThis.String(object.issuerReferenceId)
                : '',
        };
        if (isSet(object.cardBackend)) {
            message.cardBackend = cardBackendFromJSON(object.cardBackend);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardBackend !== undefined && message.cardBackend !== CardBackend.INVALID_CARD_BACKEND) {
            obj.cardBackend = cardBackendToJSON(message.cardBackend);
        }
        if (message.issuerReferenceId !== '') {
            obj.issuerReferenceId = message.issuerReferenceId;
        }
        return obj;
    },
    create(base) {
        return exports.SimulateWinDisputeRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateWinDisputeRequest();
        message.cardBackend = object.cardBackend ?? CardBackend.INVALID_CARD_BACKEND;
        message.issuerReferenceId = object.issuerReferenceId ?? '';
        return message;
    },
};
function createBaseSimulateWinDisputeResponse() {
    return {};
}
exports.SimulateWinDisputeResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SimulateWinDisputeResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSimulateWinDisputeResponse();
        return message;
    },
};
function createBaseSimulateLoseDisputeRequest() {
    return {
        cardBackend: CardBackend.INVALID_CARD_BACKEND,
        issuerReferenceId: '',
        reason: dispute_loss_reason_1.DisputeLossReason.INVALID_DISPUTE_LOSS_REASON,
    };
}
exports.SimulateLoseDisputeRequest = {
    fromJSON(object) {
        const message = {
            issuerReferenceId: isSet(object.issuerReferenceId)
                ? globalThis.String(object.issuerReferenceId)
                : '',
        };
        if (isSet(object.cardBackend)) {
            message.cardBackend = cardBackendFromJSON(object.cardBackend);
        }
        if (isSet(object.reason)) {
            message.reason = (0, dispute_loss_reason_1.disputeLossReasonFromJSON)(object.reason);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardBackend !== undefined && message.cardBackend !== CardBackend.INVALID_CARD_BACKEND) {
            obj.cardBackend = cardBackendToJSON(message.cardBackend);
        }
        if (message.issuerReferenceId !== '') {
            obj.issuerReferenceId = message.issuerReferenceId;
        }
        if (message.reason !== undefined &&
            message.reason !== dispute_loss_reason_1.DisputeLossReason.INVALID_DISPUTE_LOSS_REASON) {
            obj.reason = (0, dispute_loss_reason_1.disputeLossReasonToJSON)(message.reason);
        }
        return obj;
    },
    create(base) {
        return exports.SimulateLoseDisputeRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateLoseDisputeRequest();
        message.cardBackend = object.cardBackend ?? CardBackend.INVALID_CARD_BACKEND;
        message.issuerReferenceId = object.issuerReferenceId ?? '';
        message.reason = object.reason ?? dispute_loss_reason_1.DisputeLossReason.INVALID_DISPUTE_LOSS_REASON;
        return message;
    },
};
function createBaseSimulateLoseDisputeResponse() {
    return {};
}
exports.SimulateLoseDisputeResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SimulateLoseDisputeResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSimulateLoseDisputeResponse();
        return message;
    },
};
function createBaseSimulateSettlementRequest() {
    return { transactionIds: [], currency: '' };
}
exports.SimulateSettlementRequest = {
    fromJSON(object) {
        const message = {
            transactionIds: globalThis.Array.isArray(object?.transactionIds)
                ? object.transactionIds.map((e) => globalThis.String(e))
                : [],
            currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transactionIds?.length) {
            obj.transactionIds = message.transactionIds;
        }
        if (message.currency !== '') {
            obj.currency = message.currency;
        }
        return obj;
    },
    create(base) {
        return exports.SimulateSettlementRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateSettlementRequest();
        message.transactionIds = object.transactionIds?.map((e) => e) || [];
        message.currency = object.currency ?? '';
        return message;
    },
};
function createBaseSimulateSettlementResponse() {
    return { settlementId: '' };
}
exports.SimulateSettlementResponse = {
    fromJSON(object) {
        const message = {
            settlementId: isSet(object.settlementId) ? globalThis.String(object.settlementId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.settlementId !== '') {
            obj.settlementId = message.settlementId;
        }
        return obj;
    },
    create(base) {
        return exports.SimulateSettlementResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateSettlementResponse();
        message.settlementId = object.settlementId ?? '';
        return message;
    },
};
function createBaseSimulateCashAdvanceSettlementRequest() {
    return { transactionIds: [], currency: '' };
}
exports.SimulateCashAdvanceSettlementRequest = {
    fromJSON(object) {
        const message = {
            transactionIds: globalThis.Array.isArray(object?.transactionIds)
                ? object.transactionIds.map((e) => globalThis.String(e))
                : [],
            currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transactionIds?.length) {
            obj.transactionIds = message.transactionIds;
        }
        if (message.currency !== '') {
            obj.currency = message.currency;
        }
        return obj;
    },
    create(base) {
        return exports.SimulateCashAdvanceSettlementRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateCashAdvanceSettlementRequest();
        message.transactionIds = object.transactionIds?.map((e) => e) || [];
        message.currency = object.currency ?? '';
        return message;
    },
};
function createBaseSimulateCashAdvanceSettlementResponse() {
    return { settlementId: '' };
}
exports.SimulateCashAdvanceSettlementResponse = {
    fromJSON(object) {
        const message = {
            settlementId: isSet(object.settlementId) ? globalThis.String(object.settlementId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.settlementId !== '') {
            obj.settlementId = message.settlementId;
        }
        return obj;
    },
    create(base) {
        return exports.SimulateCashAdvanceSettlementResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSimulateCashAdvanceSettlementResponse();
        message.settlementId = object.settlementId ?? '';
        return message;
    },
};
function cardBackendFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CARD_BACKEND':
            return CardBackend.INVALID_CARD_BACKEND;
        case 1:
        case 'LEDGER':
            return CardBackend.LEDGER;
        case 2:
        case 'STRIPE':
            return CardBackend.STRIPE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CardBackend.UNRECOGNIZED;
    }
}
exports.cardBackendFromJSON = cardBackendFromJSON;
function cardBackendToJSON(object) {
    switch (object) {
        case CardBackend.INVALID_CARD_BACKEND:
            return 'INVALID_CARD_BACKEND';
        case CardBackend.LEDGER:
            return 'LEDGER';
        case CardBackend.STRIPE:
            return 'STRIPE';
        case CardBackend.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.cardBackendToJSON = cardBackendToJSON;
/**
 * Test Payment Simulation Service.
 *
 * Used to simulate card transactions.
 */
class PaymentSimulationServiceClient {
    rpc;
    name = 'com.step.testapi.payment.proto.PaymentSimulationService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/test';
    methods = [{
            name: 'SimulateAuthorization',
            requestType: exports.SimulateAuthorizationRequest,
            responseType: exports.SimulateAuthorizationResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SimulateReversal',
            requestType: exports.SimulateReversalRequest,
            responseType: exports.SimulateReversalResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SimulateCapture',
            requestType: exports.SimulateCaptureRequest,
            responseType: exports.SimulateCaptureResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SimulateForceCapture',
            requestType: exports.SimulateForceCaptureRequest,
            responseType: exports.SimulateForceCaptureResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SimulateRefund',
            requestType: exports.SimulateRefundRequest,
            responseType: exports.SimulateRefundResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SimulateForceRefund',
            requestType: exports.SimulateForceRefundRequest,
            responseType: exports.SimulateForceRefundResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SimulateOpenDispute',
            requestType: exports.SimulateOpenDisputeRequest,
            responseType: exports.SimulateOpenDisputeResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SimulateWinDispute',
            requestType: exports.SimulateWinDisputeRequest,
            responseType: exports.SimulateWinDisputeResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SimulateLoseDispute',
            requestType: exports.SimulateLoseDisputeRequest,
            responseType: exports.SimulateLoseDisputeResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SimulateSettlement',
            requestType: exports.SimulateSettlementRequest,
            responseType: exports.SimulateSettlementResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SimulateCashAdvanceSettlement',
            requestType: exports.SimulateCashAdvanceSettlementRequest,
            responseType: exports.SimulateCashAdvanceSettlementResponse,
            authenticationOptions: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Simulates a card authorization.
     */
    simulateAuthorization(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Simulates a payment reversal.
     */
    simulateReversal(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Simulates a card force capture.
     */
    simulateCapture(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Simulates a force capture.
     */
    simulateForceCapture(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Simulates a payment refund.
     */
    simulateRefund(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Simulates a forced refund.
     */
    simulateForceRefund(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Simulates a dispute being opened with the issuer.
     */
    simulateOpenDispute(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Simulates a dispute being won.
     */
    simulateWinDispute(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[7],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Simulates a dispute being lost.
     */
    simulateLoseDispute(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[8],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Simulates a card settlement
     */
    simulateSettlement(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[9],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Simulates a cash advance settlement
     */
    simulateCashAdvanceSettlement(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[10],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.PaymentSimulationServiceClient = PaymentSimulationServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=payment-simulation-service.js.map